/**
 * Ryan O'Dowd
 * 2022-04-07
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, windowWidth, colors, isDarkMode}) => {
  return {
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 8,
      marginRight: 8,
      marginBottom: 16,
    },
    innerContainer: {
      flex: 1,
      paddingBottom: 8,
    },
    innerContainerScroll: {
      flexGrow: 1,
      minWidth: Math.min(500, windowWidth - 64), // @TODO: don't hardcode the padding here
      alignItems: 'center',
      paddingTop: 16,
      paddingLeft: 32,
      paddingRight: 32,
    },
    graphic: {
      marginBottom: 16,
      resizeMode: 'contain',
    },
    elephantGraphic: {
      width: 180,
      height: 180,
    },
    brainGraphic: {
      width: 160,
      height: 260,
    },
    summaryTextWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      marginBottom: 32,
    },
    progressBarWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      marginBottom: 32,
    },
    progressBar: {
      display: 'flex',
      height: globalScale * 32,
      borderRadius: globalScale * 8,
    },
    progressText: {
      position: 'absolute',
      left: globalScale * 8,
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.black,
    },
    encouragingText: {
      fontSize: globalScale * 16,
      color: colors.white,
      paddingBottom: globalScale * 8,
    },
    infoRow: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 8,
    },
    text: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    bonusRow: {
      color: colors.complete,
    },
    totalSeparator: {
      width: '100%',
      borderTopColor: isDarkMode ? colors.primaryLight : colors.primaryDark,
      borderTopWidth: 4,
      marginTop: 8,
      marginBottom: 8,
    },
    finalRow: {
      fontSize: globalScale * 20,
      color: colors.accent,
    },
    lifetimeRow: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
    },
    belowWrapper: {
      width: '100%',
      maxWidth: 800,
      marginTop: 32,
    },
    dailyRingsWrapper: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    dailyRingsTitle: {
      marginBottom: 8,
    },
    streakGraphTitle: { // @TODO: abstact with StreakRepairDisplay styles
      fontSize: globalScale * 16,
      alignSelf: 'flex-start',
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 8,
    },
    buttonWrapper: {
      display: 'flex',
    },
    playAgainIcon: {
      fontSize: globalScale * 14,
    },
  };
};

export default getStyles;
